<template>
	<div :class="classes">
		<div class="leaderboard-grid__first">
			<ThumbnailPolaroid
				v-if="first"
				:submission="first"
				:wall="wall"
				numbered
				large
				@click="select"
			/>
		</div>
		<Gallery
			numbered
			:layout="layout"
			:wall="wall"
			:results="rest"
			@view="select"
		/>
	</div>
</template>

<script>
import { enums } from 'protoswipe-shared'
import ThumbnailPolaroid from '@/components/main/ThumbnailPolaroid'
import Gallery from '@/components/main/Gallery'

export default {
	name: 'LeaderboardGrid',
	props: {
		results: Array,
		wall: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			hovered: null
		}
	},
	computed: {
		classes() {
			return ['leaderboard-grid', { 'leaderboard-grid--wall': this.wall }]
		},
		layout() {
			return this.wall ? 'wall-leaderboard' : 'odd'
		},
		empty() {
			return this.results.length === 0
		},
		text() {
			if (this.empty) return null
			return this.first.campaign.type === enums.CampaignType.text
		},
		resultsWithPosition() {
			return this.results.map((result, index) => {
				return { ...result, position: index + 1 }
			})
		},
		first() {
			return this.resultsWithPosition[0] || null
		},
		rest() {
			return this.resultsWithPosition.slice(1)
		}
	},
	methods: {
		select(id) {
			this.$emit('view', id)
		},
		emitUpdated() {
			this.$emit('updated')
		}
	},
	watch: {
		results() {
			this.$nextTick(this.emitUpdated)
		}
	},
	mounted() {
		this.emitUpdated()
	},
	components: {
		ThumbnailPolaroid,
		Gallery
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

$gap: 0.5rem;
$br: 0.25rem;

.leaderboard-grid {
	margin: 0 auto;
	width: 100%;
	max-width: 1024px;

	&__first {
		display: flex;
		justify-content: center;
		margin: 2rem auto 3rem;
		padding: 0 1rem;
	}

	&--wall &__first {
		margin: 2rem auto 3rem;
	}

	@include mq(md) {
		&__first {
			margin: 0 auto 4rem;
		}
	}
}
</style>
